<template>
    <BasePage content-page :model="model.heroSection">
        <div class="hospice-card">
            <div class="info">
                <Button class="contact-button" as-child><a :href="`mailto:${model.contact.email}`">{{ contactButtonText
                        }}</a></Button>
                <Button class="contact-button"
                    v-if="model.isCollectionInProgress && model.contact.phoneDuringCollection" as-child><a
                        :href="`tel:${model.contact.phoneDuringCollection}`">{{
                            model.contact.translations["hospice.Contact.PhonePrefix"] }} {{
                            model.contact.phoneDuringCollection }}</a></Button>
                <Button class="contact-button" v-else as-child><a :href="`tel:${model.contact.phone}`">{{
                    model.contact.translations["hospice.Contact.PhonePrefix"] }} {{
                            model.contact.phone }}</a></Button>
                <HospiceContact :model="model.contact"></HospiceContact>
            </div>
            <GoogleMap :api-key="apiKey" :map-id="MAP_ID" :zoom="mapZoom" class="google-map" :center="mapCenter"
                :map-type-control="false" :zoom-control="false">
                <AdvancedMarker v-if="markerOptions" :options="markerOptions"></AdvancedMarker>
            </GoogleMap>
        </div>
        <div class="hospice-page">
            <div class="text-content">
                <div class="text-content-section" v-for="(item) in model.textContentItems">
                    <div class="title" v-html="item.title"></div>
                    <div class="body" v-html="item.body"></div>
                </div>
            </div>
            <HospiceGallery v-if="model.galleryImages?.length" :items="model.galleryImages"></HospiceGallery>
            <HospicePartners v-if="model.supporters?.length" :items="model.supporters"
                :title="model.translations['hospice.Supporters']">
            </HospicePartners>
            <HospicePartners v-if="model.sponsors?.length" :items="model.sponsors"
                :title="model.translations['hospice.Sponsors']">
            </HospicePartners>
            <HospicePartners v-if="model.charities?.length" :items="model.charities"
                :title="model.translations['hospice.Charities']">
            </HospicePartners>
        </div>
    </BasePage>
</template>
<script setup lang="ts">
import BasePage from '@/components/Common/BasePage/BasePage.vue';
import { IHospiceProps } from './Hospice.model';
import { computed } from 'vue';
import { Button } from '@/components/ui/button';
import { AdvancedMarker, GoogleMap } from 'vue3-google-map';
import HospiceContact from './HospiceContact/HospiceContact.vue';
import HospicePartners from './HospicePartners/HospicePartners.vue';
import { MAP_ID } from '@/contants/constant';
import HospiceGallery from './HospiceGallery/HospiceGallery.vue';

const { model } = defineProps<IHospiceProps>()


const apiKey = window.__STATE__?.mapKey ?? undefined
const markerOptions = computed<{ position: google.maps.LatLng | google.maps.LatLngLiteral | null }>(() => ({ position: model.contact.location.coordinates }))
const mapZoom = computed<number>(() => model.contact.location.zoom)
const mapCenter = computed<google.maps.LatLng | google.maps.LatLngLiteral>(() => model.contact.location.center)
const contactButtonText = computed(() => {
    return model.contactButtonText?.length
        ? model.contactButtonText
        : `${model.contact.translations["hospice.Contact.EmailPrefix"]} ${model.contact.name}`
})
</script>
<style lang="scss" scoped>
.info {
    padding: 12px 24px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    min-width: 0;

    .contact-button {
        width: fit-content;
        height: auto;
        white-space: normal;
    }
}

.hospice-card {
    display: grid;
    grid-template-columns: 1fr;
    border: 1px solid lightgray;
    border-radius: 24px;
}

.google-map {
    width: 100%;
    height: 300px;


    :deep(.mapdiv) {
        border-radius: 0 0 24px 24px;
    }
}

.hospice-page {
    margin-top: 20px;
}

.text-content {
    display: flex;
    flex-direction: column;
    gap: 15px;


    .title {
        font-size: 2.0625rem;
        margin-bottom: 10px;
        font-weight: 700;
    }

    .body {
        font-size: 1.125rem;
        line-height: 2.0625rem;

        :deep(p) {
            margin-top: 30px;
        }
    }
}

@media (min-width: 768px) {
    .hospice-card {
        grid-template-columns: 1fr 1fr;

    }

    .google-map {
        :deep(.mapdiv) {
            border-radius: 0 24px 24px 0;
        }
    }
}
</style>